import { render } from "./cancelerList.vue?vue&type=template&id=b6020666"
import script from "./cancelerList.vue?vue&type=script&lang=js"
export * from "./cancelerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__